function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhlokkDesignLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "576px",
    height: "160px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.05811,0,0,1.05811,-8.19598,-5.99408)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(50.5661,0,0,50.5661,136.499,102.238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.078,-0.708L0.309,-0.708C0.35,-0.708 0.386,-0.704 0.419,-0.697C0.452,-0.69 0.48,-0.678 0.503,-0.661C0.526,-0.644 0.544,-0.623 0.557,-0.597C0.57,-0.571 0.576,-0.54 0.576,-0.503C0.576,-0.464 0.569,-0.431 0.554,-0.404C0.539,-0.377 0.52,-0.356 0.495,-0.34C0.47,-0.323 0.44,-0.311 0.407,-0.304C0.374,-0.297 0.338,-0.293 0.301,-0.293L0.204,-0.293L0.204,-0L0.078,-0L0.078,-0.708ZM0.292,-0.399C0.313,-0.399 0.332,-0.401 0.351,-0.404C0.37,-0.407 0.386,-0.412 0.401,-0.42C0.416,-0.427 0.427,-0.438 0.436,-0.451C0.445,-0.464 0.449,-0.482 0.449,-0.503C0.449,-0.524 0.445,-0.541 0.436,-0.554C0.427,-0.567 0.416,-0.577 0.402,-0.584C0.387,-0.591 0.371,-0.596 0.353,-0.599C0.334,-0.601 0.315,-0.602 0.296,-0.602L0.204,-0.602L0.204,-0.399L0.292,-0.399Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(50.5661,0,0,50.5661,167.344,102.238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.078,-0.708L0.204,-0.708L0.204,-0.422L0.535,-0.422L0.535,-0.708L0.661,-0.708L0.661,-0L0.535,-0L0.535,-0.314L0.204,-0.314L0.204,-0L0.078,-0L0.078,-0.708Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(50.5661,0,0,50.5661,204.713,102.238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.078,-0.708L0.204,-0.708L0.204,-0.112L0.505,-0.112L0.505,-0L0.078,-0L0.078,-0.708Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(50.5661,0,0,50.5661,229.035,102.238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.044,-0.356C0.044,-0.413 0.053,-0.464 0.073,-0.51C0.092,-0.555 0.118,-0.594 0.152,-0.626C0.185,-0.658 0.225,-0.683 0.272,-0.7C0.318,-0.717 0.368,-0.726 0.423,-0.726C0.478,-0.726 0.529,-0.717 0.576,-0.7C0.623,-0.683 0.663,-0.658 0.697,-0.626C0.731,-0.594 0.757,-0.555 0.777,-0.51C0.796,-0.464 0.805,-0.413 0.805,-0.356C0.805,-0.301 0.796,-0.25 0.777,-0.205C0.757,-0.159 0.731,-0.12 0.697,-0.087C0.663,-0.054 0.623,-0.028 0.576,-0.01C0.529,0.009 0.478,0.018 0.423,0.018C0.368,0.018 0.318,0.009 0.272,-0.01C0.225,-0.028 0.185,-0.054 0.152,-0.087C0.118,-0.12 0.092,-0.159 0.073,-0.205C0.053,-0.25 0.044,-0.301 0.044,-0.356ZM0.181,-0.356C0.181,-0.318 0.187,-0.283 0.199,-0.252C0.21,-0.22 0.227,-0.192 0.249,-0.169C0.27,-0.146 0.296,-0.128 0.326,-0.115C0.355,-0.101 0.388,-0.095 0.424,-0.095C0.46,-0.095 0.493,-0.101 0.523,-0.115C0.553,-0.128 0.579,-0.146 0.601,-0.169C0.622,-0.192 0.639,-0.22 0.651,-0.252C0.662,-0.283 0.668,-0.318 0.668,-0.356C0.668,-0.393 0.662,-0.427 0.651,-0.458C0.639,-0.489 0.622,-0.517 0.601,-0.54C0.58,-0.563 0.554,-0.582 0.524,-0.595C0.494,-0.608 0.461,-0.615 0.424,-0.615C0.387,-0.615 0.354,-0.608 0.325,-0.595C0.295,-0.582 0.269,-0.563 0.248,-0.54C0.227,-0.517 0.21,-0.489 0.199,-0.458C0.187,-0.427 0.181,-0.393 0.181,-0.356Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(50.5661,0,0,50.5661,271.965,102.238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.078,-0.708L0.204,-0.708L0.204,-0.402L0.207,-0.402L0.503,-0.708L0.673,-0.708L0.342,-0.381L0.695,-0L0.518,-0L0.207,-0.355L0.204,-0.355L0.204,-0L0.078,-0L0.078,-0.708Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(50.5661,0,0,50.5661,306.805,102.238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.078,-0.708L0.204,-0.708L0.204,-0.402L0.207,-0.402L0.503,-0.708L0.673,-0.708L0.342,-0.381L0.695,-0L0.518,-0L0.207,-0.355L0.204,-0.355L0.204,-0L0.078,-0L0.078,-0.708Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(50.5661,0,0,50.5661,354.287,102.238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.698,-0.354C0.698,-0.293 0.688,-0.24 0.668,-0.196C0.648,-0.151 0.62,-0.115 0.585,-0.086C0.55,-0.057 0.508,-0.035 0.461,-0.021C0.413,-0.007 0.362,-0 0.307,-0L0.106,-0L0.106,-0.708L0.307,-0.708C0.362,-0.708 0.413,-0.701 0.461,-0.688C0.508,-0.674 0.55,-0.653 0.585,-0.624C0.62,-0.595 0.648,-0.558 0.668,-0.513C0.688,-0.468 0.698,-0.415 0.698,-0.354ZM0.129,-0.688L0.129,-0.02L0.302,-0.02C0.354,-0.02 0.403,-0.027 0.449,-0.04C0.494,-0.053 0.534,-0.073 0.567,-0.1C0.6,-0.127 0.627,-0.161 0.646,-0.203C0.665,-0.245 0.675,-0.295 0.675,-0.354C0.675,-0.413 0.665,-0.463 0.646,-0.506C0.627,-0.548 0.6,-0.583 0.567,-0.61C0.534,-0.636 0.494,-0.656 0.449,-0.669C0.403,-0.682 0.354,-0.688 0.302,-0.688L0.129,-0.688Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(50.5661,0,0,50.5661,393.223,102.238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.106,-0L0.106,-0.708L0.518,-0.708L0.518,-0.688L0.127,-0.688L0.127,-0.377L0.495,-0.377L0.495,-0.357L0.127,-0.357L0.127,-0.02L0.534,-0.02L0.534,-0L0.106,-0Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(50.5661,0,0,50.5661,423.057,102.238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.498,-0.17C0.498,-0.14 0.492,-0.113 0.481,-0.09C0.469,-0.066 0.453,-0.046 0.434,-0.03C0.415,-0.013 0.392,-0.001 0.366,0.008C0.339,0.016 0.312,0.02 0.283,0.02C0.239,0.02 0.199,0.012 0.163,-0.004C0.126,-0.019 0.096,-0.04 0.072,-0.067L0.089,-0.082C0.114,-0.055 0.144,-0.034 0.178,-0.021C0.211,-0.007 0.246,-0 0.282,-0C0.308,-0 0.333,-0.004 0.356,-0.012C0.379,-0.019 0.4,-0.03 0.418,-0.045C0.436,-0.059 0.45,-0.077 0.461,-0.098C0.471,-0.119 0.476,-0.143 0.476,-0.17C0.476,-0.197 0.47,-0.22 0.459,-0.239C0.448,-0.258 0.433,-0.274 0.415,-0.287C0.397,-0.3 0.377,-0.312 0.354,-0.321C0.331,-0.33 0.307,-0.338 0.284,-0.345C0.255,-0.354 0.228,-0.364 0.204,-0.375C0.179,-0.385 0.158,-0.398 0.141,-0.413C0.123,-0.428 0.109,-0.446 0.1,-0.467C0.09,-0.488 0.085,-0.513 0.085,-0.543C0.085,-0.572 0.091,-0.599 0.103,-0.622C0.114,-0.645 0.13,-0.664 0.15,-0.68C0.17,-0.695 0.193,-0.707 0.22,-0.716C0.246,-0.724 0.274,-0.728 0.303,-0.728C0.339,-0.728 0.373,-0.721 0.406,-0.708C0.438,-0.694 0.464,-0.674 0.485,-0.649L0.468,-0.634C0.449,-0.657 0.426,-0.676 0.397,-0.689C0.368,-0.701 0.336,-0.708 0.302,-0.708C0.278,-0.708 0.255,-0.705 0.232,-0.698C0.209,-0.691 0.188,-0.681 0.169,-0.668C0.15,-0.654 0.135,-0.637 0.124,-0.616C0.113,-0.595 0.107,-0.571 0.107,-0.543C0.107,-0.516 0.112,-0.493 0.122,-0.474C0.132,-0.455 0.145,-0.438 0.162,-0.425C0.179,-0.412 0.198,-0.401 0.219,-0.392C0.24,-0.383 0.261,-0.375 0.283,-0.368C0.313,-0.358 0.341,-0.348 0.367,-0.338C0.393,-0.327 0.416,-0.315 0.436,-0.3C0.455,-0.285 0.47,-0.268 0.482,-0.247C0.493,-0.226 0.498,-0.2 0.498,-0.17Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(50.5661,0,0,50.5661,451.88,102.238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.106,
    y: -0.708,
    width: 0.022,
    height: 0.708,
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(50.5661,0,0,50.5661,463.712,102.238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.699,-0.041C0.671,-0.026 0.636,-0.012 0.593,0.001C0.55,0.014 0.501,0.02 0.445,0.02C0.389,0.02 0.338,0.01 0.292,-0.009C0.246,-0.028 0.207,-0.055 0.174,-0.089C0.141,-0.122 0.116,-0.162 0.099,-0.208C0.081,-0.253 0.072,-0.303 0.072,-0.356C0.072,-0.409 0.081,-0.459 0.099,-0.505C0.117,-0.55 0.142,-0.59 0.175,-0.623C0.207,-0.656 0.246,-0.681 0.291,-0.7C0.336,-0.719 0.386,-0.728 0.441,-0.728C0.489,-0.728 0.533,-0.721 0.573,-0.706C0.613,-0.691 0.648,-0.671 0.679,-0.646L0.663,-0.63C0.65,-0.643 0.634,-0.654 0.617,-0.664C0.599,-0.673 0.58,-0.681 0.561,-0.688C0.541,-0.695 0.521,-0.7 0.5,-0.703C0.479,-0.706 0.459,-0.708 0.44,-0.708C0.388,-0.708 0.341,-0.699 0.298,-0.681C0.255,-0.662 0.219,-0.637 0.189,-0.605C0.158,-0.573 0.135,-0.536 0.119,-0.493C0.102,-0.45 0.094,-0.405 0.094,-0.356C0.094,-0.307 0.102,-0.261 0.118,-0.218C0.134,-0.175 0.157,-0.137 0.188,-0.105C0.218,-0.072 0.255,-0.047 0.299,-0.028C0.342,-0.009 0.392,-0 0.447,-0C0.495,-0 0.538,-0.005 0.575,-0.015C0.612,-0.025 0.647,-0.038 0.678,-0.053L0.678,-0.331L0.494,-0.331L0.494,-0.35L0.699,-0.35L0.699,-0.041Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(50.5661,0,0,50.5661,503.912,102.238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.639,-0L0.131,-0.68L0.128,-0.68L0.128,-0L0.106,-0L0.106,-0.708L0.137,-0.708L0.646,-0.029L0.649,-0.029L0.649,-0.708L0.671,-0.708L0.671,-0L0.639,-0Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(146.437,0,0,146.437,36.0175,96.8806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.279,-0C0.257,-0 0.237,-0.002 0.218,-0.007L0.243,-0.108C0.254,-0.104 0.266,-0.102 0.279,-0.102C0.299,-0.102 0.318,-0.106 0.336,-0.114C0.354,-0.121 0.37,-0.132 0.383,-0.145C0.396,-0.158 0.407,-0.174 0.415,-0.192C0.422,-0.21 0.426,-0.229 0.426,-0.25C0.426,-0.27 0.422,-0.289 0.415,-0.307C0.407,-0.324 0.396,-0.34 0.383,-0.353C0.37,-0.366 0.354,-0.377 0.336,-0.385C0.318,-0.392 0.299,-0.396 0.279,-0.396C0.259,-0.396 0.24,-0.392 0.222,-0.385C0.204,-0.377 0.188,-0.366 0.175,-0.353C0.162,-0.34 0.151,-0.324 0.144,-0.307C0.136,-0.289 0.132,-0.27 0.132,-0.25L0.132,0.233L0.03,0.13L0.03,-0.25C0.03,-0.284 0.037,-0.316 0.05,-0.347C0.063,-0.377 0.08,-0.403 0.103,-0.426C0.125,-0.449 0.151,-0.467 0.182,-0.48C0.212,-0.493 0.244,-0.5 0.279,-0.5C0.313,-0.5 0.345,-0.493 0.376,-0.48C0.407,-0.467 0.433,-0.449 0.456,-0.426C0.479,-0.403 0.497,-0.377 0.51,-0.347C0.523,-0.316 0.53,-0.284 0.53,-0.25C0.53,-0.215 0.523,-0.183 0.51,-0.153C0.497,-0.122 0.479,-0.096 0.456,-0.073C0.433,-0.05 0.407,-0.033 0.376,-0.02C0.345,-0.007 0.313,-0 0.279,-0Z",
    style: {
      fill: "url(#_Linear1)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.5,0,0,0.733,0.03,-0.1335)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(32,177,254)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(227,14,253)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhlokkDesignLogo);
export default __webpack_public_path__ + "static/media/phlokk-design-logo.3c24229748b4e26fd47738486536cf11.svg";
export { ForwardRef as ReactComponent };